import React from 'react';
import Voucher from './Voucher';
import styles from './voucher.module.scss';

type VoucherBannerProps = {
  voucher: WebExperienceApiContract.Models.Voucher;
};

const VoucherBanner = ({ voucher }: VoucherBannerProps) => (
  <div className="container-fluid">
    <div className="row pb-3 pt-3 px-3">
      <div className="col-md-6 rounded d-none d-md-block mb-3">
        <h3 className="fs-3">
          Spend your £50 voucher on a car service at home or work.
        </h3>
        <p>
          Skip the hassle of going to a garage. RAC Mobile Mechanics come to you.
        </p>
      </div>
      <div className={`${styles.customBorder} col-md-6 rounded bg-white`}>
        <div className="row">
          <div className="pt-3">
            <h3 className={styles.bannerArrow}>Your £50 service voucher</h3>
          </div>
        </div>
        <div className="row pb-2 mb-2 pb-md-0 mb-md-0">
          <div className="col-md-5">
            <p>
              Skip the hassle of going to a garage. RAC Mobile Mechanics come to you.
            </p>
          </div>
          <div className="col-sm-8 col-md-7">
            <Voucher voucher={voucher} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default VoucherBanner;
